<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>Produkte verwalten</h3>
        </div>
        <div class="card-toolbar">
          <v-btn
            class="px-7 py-3 font-size-3 text-white invite-btn"
            @click="goToAddNew"
          >
            <b-icon
              icon="plus-circle-fill"
              scale="1"
              aria-hidden="true"
              variant="light"
              class="mr-2"
            ></b-icon>
            Neu hinzufügen
          </v-btn>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th class="text-center align-middle" width="8%">
                  Seriennummer
                </th>
                <th
                  width="20%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'product_name',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Produktname
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'product_name'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'product_name' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'product_name' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <!-- <th class="text-center align-middle">Description</th>-->

                <th
                  width="15%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'lowest_price',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Preis
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'lowest_price'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'lowest_price' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'lowest_price' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <!-- <th class="text-center align-middle" width="15%">Produktpreis</th> -->
                <!-- <th class="text-center align-middle" width="15%" @click="
                    sortListing(
                      'available_stock',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  ">Lagerstand
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'available_stock'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'available_stock' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'available_stock' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th> -->
                <th class="text-center align-middle" width="18%">Status</th>
                <th class="text-center align-middle" width="10%">
                  Vorschaubild
                </th>
                <th class="text-center align-middle" width="15%">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchNameKey"
                    solo
                    label="Name suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchPriceKey"
                    solo
                    label="Search Preis..."
                    clearable
                  ></v-text-field>
                  <!-- <v-select
                    :items="unitsList"
                    v-model="searchUnitKey"
                    item-text="unit"
                    item-value="id"
                    label="Einheit wird gesucht..."
                    solo
                    clearable
                  /> -->
                </div>
              </td>
              <!-- <td></td> -->
              <td>
                <v-select
                  :items="statusItems"
                  v-model="searchStatusKey"
                  item-text="title"
                  item-value="value"
                  label="Status wird gesucht..."
                  solo
                  clearable
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tbody v-if="products.length">
              <tr v-for="(product, i) in products" :key="product.id">
                <td
                  class="align-middle clickable-td"
                  @click="goToEdit(product.id)"
                >
                  {{ i + 1 }}
                </td>
                <td
                  class="align-middle clickable-td"
                  @click="goToEdit(product.id)"
                >
                  {{
                    product.product_name.length > 30
                      ? product.product_name.substr(0, 30) + "..."
                      : product.product_name
                  }}
                </td>
                <td
                  v-if="product.lowest_price"
                  class="align-middle clickable-td text-center"
                  @click="goToEdit(product.id)"
                >
                  {{
                    product.lowest_price ? product.lowest_price.replace('.', ',') : "-"
                  }}
                </td>
                <td v-else class="align-middle clickable-td text-center"
                  @click="goToEdit(product.id)">
                  -
                </td>
                <!-- <td
                  class="align-middle clickable-td text-center"
                  @click="goToEdit(product.id)"
                >
                  {{
                    product.available_stock
                  }}
                </td> -->
                <td
                  class="align-middle clickable-td"
                  @click="goToEdit(product.id)"
                >
                  {{
                    product.is_status == 0
                      ? "Entwurf"
                      : product.is_status == 2
                      ? "Online"
                      : "Offline"
                  }}
                </td>
                <td class="align-middle text-center">
                  <img
                    v-if="product.pictures.length"
                    class="table-image"
                    :src="
                      product.pictures[0].photo_path
                        ? product.pictures[0].photo_path
                        : ''
                    "
                    alt=""
                    height="50px"
                    width="50px"
                    v-on:click="
                      openFileModal(
                        product.pictures[0].photo_path
                          ? product.pictures[0].photo_path
                          : ''
                      )
                    "
                  />
                  <img
                    v-if="!product.pictures.length"
                    class="table-image"
                    src="media/images/no-image-50x50.jpg"
                    alt=""
                    height="50px"
                    width="50px"
                  />
                </td>
                <td class="align-middle text-center icon-wrapper-block">
                  <router-link :to="'/dealer/edit-product/' + product.id">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i v-bind="attrs" v-on="on" class="flaticon-edit-1"></i>
                      </template>
                      <span>Bearbeiten</span>
                    </v-tooltip>
                  </router-link>
                  <!-- <a @click="addStockClicked(product.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          icon="plus-circle"
                          scale="1.2"
                          v-bind="attrs"
                          v-on="on"
                        ></b-icon>
                      </template>
                      <span>Lagerstand hinzufügen</span>
                    </v-tooltip>
                  </a> -->
                  <a
                    v-if="product.is_status == 2"
                    @click="changeStatus(product.id, product.is_status)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Online</span>
                    </v-tooltip>
                  </a>
                  <a
                    v-if="product.is_status == 3"
                    @click="changeStatus(product.id, product.is_status)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Offline</span>
                    </v-tooltip>
                  </a>
                  <a v-if="product.is_status == 0">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="hourglass"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Entwurf</span>
                    </v-tooltip>
                  </a>

                  <a v-if="product.is_status == 1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="hourglass"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Freigabe offen</span>
                    </v-tooltip>
                  </a>

                  <a @click="deleteProduct(product.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="trash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Löschen</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="loading_products" class="loading-tbody">
              <td colspan="10">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody">
              <tr>
                <td colspan="10">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                    rel="prev"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                    rel="next"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showFileModal"
      class="file-modal"
      centered
      hide-footer
      resizable
    >
      <div v-if="modalFile">
        <div>
          <b-img :src="modalFile" class="modal-image"></b-img>
        </div>
      </div>
    </b-modal>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="stockFormDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Lagerstand hinzufügen
        </v-card-title>

        <ValidationObserver ref="newStockForm">
          <b-form class="form" @submit.stop.prevent="submitStock">
            <v-card-text>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{
                  required: 'Der Abzeichen Name ist erforderlich',
                }"
              >
                <v-text-field
                  type="number"
                  v-model="productStock"
                  :error-messages="errors[0]"
                  autocomplete="new-password"
                  placeholder="Lagerstand"
                  outlined
                ></v-text-field>
              </ValidationProvider>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                :disabled="disabledCancel"
                class="no-button"
                @click="hideModal"
              >
                Abbrechen
              </v-btn>
              <v-btn
                type="submit"
                ref="kt_form_submit_btn"
                class="yes-button"
                :loading="yesActionLoading"
              >
                Abschicken
              </v-btn>
            </v-card-actions>
          </b-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <notifications group="producersproduct" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import providerAPI from "@/api/provider";
import { LOGOUT } from "@/core/services/store/auth.module";

Vue.use(Notifications);

export default {
  name: "Products",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.getproducts();
      const unitsPromise = this.getProductUnits();
      Promise.all([unitsPromise]);
    }
  },
  data() {
    return {
      loading_products: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchNameKey: "",
      //searchDescriptionKey: "",
      searchPriceKey: "",
      searchStatusKey: "",
      searchUnitKey: "",
      stockErr: "",
      userId: null,
      showFileModal: false,
      modalFile: null,
      products: [],
      statusDialog: false,
      deleteDialog: false,
      deleteRecordId: null,
      statusRecordId: null,
      yesActionLoading: false,
      disabledCancel: false,
      stockFormDialog: false,
      selectedProductStk: "",
      productStock: "",
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
      statusItems: [
        {
          title: "Entwurf",
          value: "0",
        },
        {
          title: "Online",
          value: "2",
        },
        {
          title: "Offline",
          value: "3",
        },
      ],
      unitsList: [],
    };
  },
  components: {
    // 'money-format': MoneyFormat
  },
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },
    /*searchDescriptionKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },*/
    searchPriceKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },
    searchStatusKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },

    searchUnitKey: {
      handler: function (val, oldVal) {
        this.products = [];
        this.loading_products = true;
        this.getproducts();
      },
      deep: true,
    },
  },
  methods: {
    addStockClicked(id) {
      this.selectedProductStk = id;
      this.stockFormDialog = true;
    },
    submitStock() {
      this.$refs.newStockForm.validate().then((success) => {
        if (success) {
          this.disabledCancel = true;
          this.yesActionLoading = true;
          let data = {
            user_id: this.currentUser.id,
            product_id: this.selectedProductStk,
            stock: this.productStock,
          };
          providerAPI
            .addProductStock(data)
            .then((response) => {
              if (response.status === "success") {
                this.disabledCancel = false;
                this.yesActionLoading = false;
                this.selectedProductStk = "";
                this.productStock = "";
                this.stockFormDialog = false;
                this.getproducts()
                this.$notify({
                  group: "producersproduct",
                  type: "success",
                  position: "bottom right",
                  text: response.msg,
                  duration: 3000,
                });
              } else {
                this.disabledCancel = false;
                this.yesActionLoading = false;
                this.selectedProductStk = "";
                this.productStock = "";
                this.stockFormDialog = false;
                this.$notify({
                  group: "producersproduct",
                  type: "error",
                  position: "bottom right",
                  text: response.msg,
                  duration: 3000,
                });
              }
            })
            .catch((err) => {
              this.disabledCancel = false;
              this.yesActionLoading = false;
              this.selectedProductStk = "";
              this.productStock = "";
              this.stockFormDialog = false;
              this.$notify({
                group: "producersproduct",
                type: "error",
                position: "bottom right",
                text: err,
                duration: 3000,
              });
            });
        }
      });
    },
    goToEdit(id) {
      this.$router.push({ path: "/dealer/edit-product/" + id });
    },
    goToAddNew() {
      this.$router.push({ name: "producer-add-product" });
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
      this.stockFormDialog = false;
    },
    clearInput(type) {
      switch (type) {
        case "name":
          this.searchNameKey = "";
          break;

        /*case "description":
          this.searchDescriptionKey = "";
          break;*/

        // case "price":
        //   this.searchPriceKey = "";
        //   break;
      }
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_products) {
        this.products = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_products = true;
        this.getproducts();
      }
    },
    openFileModal(file) {
      this.showFileModal = true;
      this.modalFile = file;
    },
    paginationChange() {
      this.products = [];
      this.loading_products = true;
      setTimeout(() => {
        this.getproducts();
      }, 100);
    },
    getproducts() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        search_name_field: this.searchNameKey,
        search_status_field: this.searchStatusKey,
        search_unit_field: this.searchUnitKey,
        search_price_field:this.searchPriceKey ? this.searchPriceKey.replace(',', '.') :'',
        per_page: this.pagination.perPage,
        sort_column: this.filter.orderCol,
        sort_type: this.filter.orderBy,
      };

      providerAPI
        .getProducts(data)
        .then((response) => {
          if (response.status == "success") {
            this.products = response.data;
            this.pagination.paginationRows = response.count;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_products = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_products = false;
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        }, (error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("userCheckoutDetails");
            this.$store.dispatch(LOGOUT).then(() => {
              setTimeout(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                this.$router.push({ name: "login" });
              }, 2000);
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_products = false;
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deleteProduct(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.disabledCancel = true;
      this.yesActionLoading = true;
      axios
        .post("producer/delete-product", { id: id })
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "producersproduct",
              type: "success",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getproducts();
          } else {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.deleteDialog = false;
          this.deleteRecordId = null;
          this.disabledCancel = false;
          this.yesActionLoading = false;
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status) {
      if (status == 0) {
        this.newStatus = "1";
      } else if (status == 2) {
        this.newStatus = "3";
      } else if (status == 3) {
        this.newStatus = "2";
      } else {
        this.newStatus = "0";
      }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    getProductUnits() {
      providerAPI
        .getProductUnits()
        .then((response) => {
          if (response.status == "success") {
            this.unitsList = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;

      providerAPI
        .statusProduct({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producersproduct",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.getproducts();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
/*h3 {
  font-family: "ubuntu";
  color: #000;
}*/

/*.invite-btn {
  background-color: #3d5a80 !important;
}

.invite-btn:hover {
  background-color: #002c47 !important;
}
.submit-btn-fill-color {
  background-color: #ff5252 !important;
}

.submit-btn-fill-color:hover {
  background-color: red !important;
}*/
.new-btn-text {
  margin-left: 10px;
  font-size: 13px;
}
.vue-star-rating {
    justify-content: center !important;
}
a {
  cursor: pointer;
}

.file-modal {
  padding: 0;
  margin: 0;
}

.modal-image {
  width: 100%;
}

.table-image {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.loading-tbody {
  text-align: center;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}
.clickable-td {
  cursor: pointer;
}
</style>